module.exports = __webpack_public_path__ + "static/media/principles-of-econ-not-enrolled.33e8bf94.svg";